<section id="process" aria-labelledby="process-heading" class="border-t border-cp-line">
  <div [class]="inner + ' ' + pad">
    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-12">
      <h2 id="process-heading" [class]="h2">One request.<br />Competing terms.</h2>
      <p [class]="lead + ' max-w-[44ch] lg:pt-2'">
        Simplifying the way advisors access and source credit, while protecting assets under management.
      </p>
    </div>

    <ol class="mt-16 grid grid-cols-1 border-t border-cp-line sm:grid-cols-2 lg:grid-cols-4">
      @for (step of steps; track step.title; let i = $index) {
        <li [class]="'border-cp-line py-8 sm:pr-8 ' + (i > 0 ? 'max-sm:border-t ' : '') + (i % 2 === 1 ? 'sm:border-l sm:pl-8 ' : '') + (i > 1 ? 'sm:max-lg:border-t ' : '') + (i === 2 ? 'lg:border-l lg:pl-8 ' : '')">
          <h3 [class]="h3">{{ step.title }}</h3>
          <p [class]="body + ' mt-2'">{{ step.description }}</p>
        </li>
      }
    </ol>

    <figure class="mt-12 lg:mt-16">
      <app-offers-preview />
      <figcaption class="mt-3 text-right text-[12px] text-cp-subtle">Sample data. Terms are illustrative.</figcaption>
    </figure>
  </div>
</section>
